import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const EmergencyResponsePlan = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  emergencyContact,
  safetyOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Emergency_Response_Plan.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Emergency Response Plan</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        The purpose of this Emergency Response Plan is to establish procedures to effectively manage emergencies to protect life, property, and the environment, ensuring a swift and coordinated response.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This plan applies to all employees, contractors, and visitors of {clientName || "the Company"} at all operational sites and during company activities.
      </p>

      <h4 className="section-title">3. Emergency Situations Covered</h4>
      <ul>
        <li>Fire and explosion</li>
        <li>Medical emergencies</li>
        <li>Road traffic accidents involving company vehicles</li>
        <li>Hazardous material spills or leaks</li>
        <li>Natural disasters (flooding, storms, etc.)</li>
        <li>Security threats</li>
      </ul>

      <h4 className="section-title">4. Roles and Responsibilities</h4>
      <p className="section-content"><strong>Employees:</strong> Must be familiar with emergency procedures and report emergencies immediately.</p>
      <p className="section-content"><strong>Emergency Response Team:</strong> Responsible for coordinating emergency response, evacuation, and communication.</p>
      <p className="policy-details"><strong>Safety Officer:</strong> {safetyOfficerContact || "[Insert Contact Number]"}</p>
      <p className="policy-details"><strong>Emergency Contact Number:</strong> {emergencyContact || "[Insert Contact Number]"}</p>

      <h4 className="section-title">5. Emergency Procedures</h4>
      <ul>
        <li><strong>Alarm Activation:</strong> Immediate activation of alarm system upon detecting an emergency.</li>
        <li><strong>Evacuation:</strong> Safe and orderly evacuation to designated assembly points.</li>
        <li><strong>First Aid:</strong> Prompt medical assistance provided by trained personnel.</li>
        <li><strong>Emergency Services:</strong> Contact relevant emergency services as required.</li>
        <li><strong>Communication:</strong> Clear internal and external communication throughout the incident.</li>
      </ul>

      <h4 className="section-title">6. Training and Drills</h4>
      <p className="section-content">
        Regular training and emergency drills will be conducted to ensure employee preparedness and the effectiveness of emergency procedures.
      </p>

      <h4 className="section-title">7. Incident Reporting and Review</h4>
      <p className="section-content">
        All emergencies and near misses must be reported and documented. Post-incident reviews will be conducted to identify lessons learned and improve future responses.
      </p>

      <h4 className="section-title">8. Plan Review</h4>
      <p className="section-content">
        This Emergency Response Plan will be reviewed at least annually or after any major incident to ensure its continued effectiveness.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I have read, understood, and agree to comply with the Emergency Response Plan.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This plan has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default EmergencyResponsePlan;
